import React from 'react';
import { Row, Col } from '../../../../grid';
import { Image } from '../../../../Image';
import RoyalUnibrewOfferText from '../../../../RoyalUnibrewOfferText';
import RenderModal from './RenderModal';

const RenderCampaignRoyal = ({
  royalUnibrew,
}) => {
  if (royalUnibrew) {
    return (
      <Col xs={12}>
        <RenderModal title={<React.Fragment>24 gratis dåseøl ved køb af mindst 60 liter udvalgt fadøl</React.Fragment>}>
          <Row>
            <Col xs={12} md={4} textCenter>
              <Image name="produkter-oelvand.royal-blanch-daase.png" maxHeight="200px" />
            </Col>
            <Col xs={12} md={8}>
              <RoyalUnibrewOfferText />
            </Col>
          </Row>
        </RenderModal>
      </Col>
    );
  }
  return (null);
};

// Export
export default RenderCampaignRoyal;
